/**
 * Presets for the history plugin
 * @module
 */

export * as classic from './classic'
